import styled from 'styled-components';

const HeaderStyles = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 900;
  width: 100%;
  padding: ${(props) => (props?.scrolled ? '0.4rem' : '1rem')} 0;
  background-color: ${(props) =>
    props?.isFrontPage && !props?.scrolled ? 'transparent' : '#fff'};
  border-bottom: ${(props) =>
    props?.isFrontPage && !props?.scrolled ? 'none' : '1px solid #ece8e7'};
  transition:
    padding 0.4s,
    background-color 0.4s,
    border-bottom 0.4s;

  .header-column {
    display: flex;
  }

  .header-menu {
    ul {
      display: flex;
      margin: 0 0 0 -0.5rem;
      padding: 0;
      list-style: none;

      li {
        margin: 0 1rem 0 0;

        &::before {
          display: none;
        }

        a {
          display: block;
          padding: 0.5rem;
          text-transform: uppercase;
          color: ${(props) =>
            props?.isFrontPage && !props?.scrolled
              ? '#fff'
              : 'var(--color-charcoal)'};
          transition: color 0.4s;
          font-size: 0.75rem;
          letter-spacing: 0.1rem;

          &:hover,
          &:focus {
            color: #000;
          }
        }

        &:last-child {
          margin: 0;
        }
      }
    }
  }

  .logo-link {
    display: flex;
    justify-content: center;
    pointer-events: ${(props) =>
      props?.isFrontPage && !props?.scrolled ? 'none' : 'initial'};
    transition: transform ease-in 0.3s;
    will-change: transform;

    .logo {
      width: 4.5rem;
      opacity: ${(props) => (props?.isFrontPage && !props?.scrolled ? 0 : 1)};
      transition:
        width 0.4s,
        opacity 0.4s;
    }

    &:hover {
      transform: scale(1.1);
    }
  }

  .location {
    display: flex;
    align-items: center;
    margin: 0 0.5rem 0 auto;
    vertical-align: middle;

    .icon {
      width: 1.4rem;
      margin: 0 0.25rem 0 0;
      fill: ${(props) =>
        props?.isFrontPage && !props?.scrolled
          ? '#fff'
          : 'var(--color-charcoal)'};
      transition: fill 0.4s;
    }

    .text {
      font-size: 0.75rem;
      line-height: 1;
      color: ${(props) =>
        props?.isFrontPage && !props?.scrolled
          ? '#fff'
          : 'var(--color-charcoal)'};
      transition: color 0.4s;
    }

    &:hover,
    &:focus {
      .icon {
        fill: #000;
      }

      .text {
        color: #000;
      }
    }
  }

  .menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    margin-right: -0.313rem;
    padding: 0.313rem;

    .icon {
      width: 1.5rem;
      fill: ${(props) =>
        props?.isFrontPage && !props?.scrolled
          ? '#fff'
          : 'var(--color-charcoal)'};
      transition: fill 0.4s;

      &:hover,
      &:focus {
        fill: #000;
      }
    }
  }

  @media (min-width: 350px) {
    .location {
      margin: 0 1.2rem 0 auto;
    }

    .logo-link .logo {
      width: ${(props) => (props?.scrolled ? '4.5rem' : '5.5rem')};
    }
  }

  @media (min-width: 400px) {
    .logo-link .logo {
      width: ${(props) => (props?.scrolled ? '5rem' : '7.5rem')};
    }
  }

  @media (min-width: 768px) {
    padding: ${(props) => (props?.scrolled ? '0.75rem' : '1.625rem')} 0;

    .header-column {
      width: 33.333%;
    }

    .header-menu ul li a {
      font-size: 1.125rem;
    }

    .logo-link {
      margin: 0 auto;

      .logo {
        width: ${(props) => (props?.scrolled ? '8rem' : '10.625rem')};
      }
    }

    .location .text {
      font-size: 1rem;
    }

    .menu-toggle {
      .icon {
        width: 1.9rem;
      }
    }
  }
`;

export default HeaderStyles;
